import "core-js/modules/es.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { addAdvertisement, getPoster, edtPoster } from "@/api/Administration/advertisingChannels";
export default {
  props: {
    showing: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _this = this;

    var validate = function validate(rule, value, callback) {
      if (value === '') {
        callback(new Error(_this.$t('pleaseInput')));
      } else if (/[A-Z\u4e00-\u9fa5]/.test(value)) {
        callback(new Error(_this.$t('cannotContainUppercaseChinese')));
      } else {
        callback();
      }
    };

    return {
      dialogFormVisible: false,
      id: "",
      titleKey: "addAdChannel",
      form: {
        name: "",
        status: "1",
        mark: ""
      },
      rules: {
        name: [{
          required: true,
          message: this.$t('pleaseInputAdName'),
          trigger: "blur"
        }],
        mark: [{
          required: true,
          validator: validate,
          trigger: "blur"
        }]
      },
      formLabelWidth: "80px"
    };
  },
  computed: {
    isShow: {
      get: function get() {
        if (this.showing) {
          return this.showing;
        }
      },
      set: function set(val) {
        this.$emit("changeShow", false);
      }
    }
  },
  created: function created() {},
  methods: {
    init: function init(id) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.dialogFormVisible = true;
                _this2.id = id;

                if (id != "t") {
                  _this2.titleKey = "modifyAdChannel";
                  getPoster({
                    id: id
                  }).then(function (res) {
                    _this2.form.name = res.data.name;
                    _this2.form.status = String(res.data.status);
                    _this2.form.mark = res.data.mark;
                  });
                } else {
                  _this2.titleKey = "addAdChannel";
                  _this2.form = {
                    name: "",
                    status: "1",
                    mark: ""
                  };
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.$emit("changeShow", false);
      this.$refs.ruleForm.clearValidate();
    },
    // 点击确认
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this3 = this;

      this.$refs.ruleForm.validate(function (vali) {
        if (vali) {
          if (_this3.id != "t") {
            _this3.form.id = _this3.id;
            edtPoster(_this3.form).then(function (res) {
              if (res.status == 200) {
                Message.success(res.message);

                _this3.$emit("refreshDataList");

                _this3.resetForm("ruleForm");
              }
            });
          } else {
            addAdvertisement(_this3.form).then(function (res) {
              if (res.status == 200) {
                Message.success(res.message);

                _this3.$emit("refreshDataList");

                _this3.resetForm("ruleForm");
              }
            });
          }
        }
      });
    }
  }
};